export const formatGiftLink = (link) => {
    if (link.slice(0, 4).toLowerCase() === 'http') {
        return link
    } else {
        return 'https://' + link
    }
}